var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('div',{staticClass:"mb-3"},[_vm._v("Categoria*:")]),_c('CategorySelect',{attrs:{"newTicket":true,"resetear":this.reset},on:{"reseted":childVal => {
    this.reset = childVal.reset
  },"changeCategory":childVal => {
    this.category = childVal !== null ? childVal.id : null
  }}}),_c('div',{staticClass:"mb-3"},[_vm._v("Subcategoria*:")]),_c('GroupSelect',{attrs:{"newTicket":true,"category":_vm.category},on:{"changeGroup":childVal => {
    this.group = childVal !== null ? childVal.id : null
  }}}),_c('div',{staticClass:"mb-3"},[_vm._v("Incidencia*:")]),_c('IncidenceSelect',{attrs:{"newTicket":true,"group":_vm.group},on:{"changeIncidence":childVal => {
    this.incidence = childVal !== null ? childVal.id : null
  }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }